import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import formReducer from 'redux-form/es/reducer';
import { reducer as toastrReducer } from 'react-redux-toastr';
import loan from './loan';
import authentication from './authentication';
import localization from './localization';
import integration from './integration';
import legalAgreements from './legalAgreements';
import click2Call from './click2Call';
import marketingConsents from './marketingConsents';
import selfservice from './selfservice';
import nordigenReducer from './nordigen';

const reducers = {
  loan,
  authentication,
  routing,
  integration,
  marketingConsents,
  toastr: toastrReducer,
  form: formReducer,
  intl: localization,
  nordigen: nordigenReducer,
};

if (MOBILE_WALLET) {
  reducers.selfservice = selfservice;
}

switch (COUNTRY) {
  case 'ES':
  case 'PL':
  case 'LT':
    reducers.legalAgreements = legalAgreements;
    break;

  default:
}

if (COUNTRY === 'ES' && !PARTNER_PORTAL) {
  reducers.click2call = click2Call;
}

export default combineReducers(reducers);
